import * as React from 'react';
import YesNoComponent from './YesNoComponent';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';

export interface PedalMarkingsProps {
  setCurrentStep: (step: number) => void;
}

const PedalMarkings: React.FC<PedalMarkingsProps> = ({ setCurrentStep }) => {
  const { setSettings } = React.useContext(TranscriptionDialogContext);
  const handleClick = (pedal: boolean) => {
    setSettings({ pedal: !!pedal }, 'piano');
    setCurrentStep(3);
  };

  return <YesNoComponent handleClick={handleClick} id="pedal" />;
};

export default PedalMarkings;
